import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=f15bb368&scoped=true&"
import script from "./UserEdit.vue?vue&type=script&lang=js&"
export * from "./UserEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15bb368",
  null
  
)

export default component.exports